import { token } from '@atlaskit/tokens';

import { hexToRGBAValues } from './hex-to-rgba-values';

const getLuminance = ({ r, g, b }: { r: number; b: number; g: number }) => {
	const RsRGB = r / 255;
	const GsRGB = g / 255;
	const BsRGB = b / 255;

	const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
	const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
	const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);

	return 0.2126 * R + 0.7152 * G + 0.0722 * B;
};
const getRatio = (...luminance: [number, number]) => {
	const lighter = Math.max(...luminance);
	const darker = Math.min(...luminance);

	return (lighter + 0.05) / (darker + 0.05);
};

/**
 * Returns a border if determined to be required based on the color contrast with
 * the background.
 *
 * @param value - The Hex color code of the value
 * @param background - The Hex color code of the background
 */
export const getBorderForValue: (value: string, background: string) => string | undefined = (
	value: string,
	background: string,
) => {
	const alphaLimit = 0.5;
	const relativeLuminanceLimit = 1.5;

	const rgba = hexToRGBAValues(value);
	const a = isNaN(rgba.a) ? 1 : rgba.a;
	const vl = getLuminance(rgba);
	const bl = getLuminance(hexToRGBAValues(background));
	const r = getRatio(vl, bl);

	return a < alphaLimit || r < relativeLuminanceLimit
		? `1px solid ${token('color.border')}`
		: undefined;
};
